class MegamenuItem extends HTMLElement {
  constructor() {
    super();
    this.initMegaMenu();
  }

  initMegaMenu() {
    // Getting the parent under which we need to show the menu
    this.parentMenuHandle = this.dataset['dropdown'];
    this.parentMenu = document.querySelector(`.mega-menu__content[data-submenu="${this?.parentMenuHandle}"]`);

    if(this.parentMenuHandle && this.parentMenu) {
      this.parentMenu.querySelector('ul.mega-menu__list')?.remove();
      this.parentMenu.closest('header-menu')?.classList.add('mm_mega-menu');

      // Add menu into the the header so it can work on hover with CSS
      // TODO: Add Accessability for the menu on hover or focus.
      this.parentMenu.innerHTML = this.innerHTML;
    }
  }

}

customElements.define('megamenu-item', MegamenuItem);